import React from "react";

const BoxLabelPrintingIcon = ({
  primaryColor = "#5062F0",
  secondaryColor = "#FFFFFF",
  width = 140,
  height = 70,
  title = "Box Label Printing Icon",
  idSuffix = "a", 
  ...svgProps
}) => {
  const maskId = `banner-masked-badge-${idSuffix}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 140 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}

      <rect x="0.120117" width="139.2" height="70" rx="12" fill={primaryColor} />

      <rect
        x="64.625"
        y="9.5"
        width="12.75"
        height="5.93333"
        rx="0.5"
        fill={secondaryColor}
        stroke={secondaryColor}
      />

      <mask id={maskId} fill="white">
        <rect x="60" y="12.4666" width="22" height="13.8667" rx="1.5" />
      </mask>

      <rect
        x="60"
        y="12.4666"
        width="22"
        height="13.8667"
        rx="1.5"
        fill={primaryColor}
        stroke={secondaryColor}
        strokeWidth="3.6"
        mask={`url(#${maskId})`}
      />

      <rect
        x="64.625"
        y="21.6334"
        width="12.75"
        height="12.8667"
        rx="1"
        fill={secondaryColor}
        stroke={secondaryColor}
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.125 16.8C75.125 16.3214 75.2349 15.9333 75.3705 15.9333H78.317C78.4526 15.9333 78.5625 16.3214 78.5625 16.8C78.5625 17.2787 78.4526 17.6667 78.317 17.6667H75.3705C75.2349 17.6667 75.125 17.2787 75.125 16.8Z"
        fill={secondaryColor}
      />

      <path
        d="M36.0941 58H34.5421V46.536H36.0941V58ZM50.9545 46.536V58H49.5945V49.576C49.5945 49.464 49.5972 49.344 49.6025 49.216C49.6132 49.088 49.6238 48.9573 49.6345 48.824L45.6985 55.992C45.5758 56.232 45.3892 56.352 45.1385 56.352H44.9145C44.6638 56.352 44.4772 56.232 44.3545 55.992L40.3385 48.792C40.3705 49.0747 40.3865 49.336 40.3865 49.576V58H39.0265V46.536H40.1705C40.3092 46.536 40.4158 46.5493 40.4905 46.576C40.5652 46.6027 40.6372 46.6773 40.7065 46.8L44.6665 53.856C44.7305 53.984 44.7918 54.1173 44.8505 54.256C44.9145 54.3947 44.9732 54.536 45.0265 54.68C45.0798 54.536 45.1358 54.3947 45.1945 54.256C45.2532 54.112 45.3172 53.976 45.3865 53.848L49.2745 46.8C49.3385 46.6773 49.4078 46.6027 49.4825 46.576C49.5625 46.5493 49.6718 46.536 49.8105 46.536H50.9545ZM57.2699 52.48C57.7125 52.48 58.1019 52.4213 58.4379 52.304C58.7792 52.1867 59.0645 52.024 59.2939 51.816C59.5285 51.6027 59.7045 51.3493 59.8219 51.056C59.9392 50.7627 59.9979 50.44 59.9979 50.088C59.9979 49.3573 59.7712 48.7867 59.3179 48.376C58.8699 47.9653 58.1872 47.76 57.2699 47.76H55.4299V52.48H57.2699ZM57.2699 46.536C57.9952 46.536 58.6245 46.6213 59.1579 46.792C59.6965 46.9573 60.1419 47.1947 60.4939 47.504C60.8459 47.8133 61.1072 48.1867 61.2779 48.624C61.4539 49.0613 61.5419 49.5493 61.5419 50.088C61.5419 50.6213 61.4485 51.1093 61.2619 51.552C61.0752 51.9947 60.8005 52.376 60.4379 52.696C60.0805 53.016 59.6352 53.2667 59.1019 53.448C58.5739 53.624 57.9632 53.712 57.2699 53.712H55.4299V58H53.8859V46.536H57.2699ZM66.6713 52.088C67.1193 52.088 67.5139 52.0347 67.8553 51.928C68.2019 51.816 68.4899 51.6613 68.7193 51.464C68.9539 51.2613 69.1299 51.0213 69.2473 50.744C69.3646 50.4667 69.4233 50.16 69.4233 49.824C69.4233 49.1413 69.1993 48.6267 68.7513 48.28C68.3033 47.9333 67.6313 47.76 66.7352 47.76H65.0393V52.088H66.6713ZM71.9673 58H70.5913C70.3086 58 70.1006 57.8907 69.9673 57.672L66.9913 53.576C66.9006 53.448 66.8019 53.3573 66.6953 53.304C66.5939 53.2453 66.4339 53.216 66.2153 53.216H65.0393V58H63.4953V46.536H66.7352C67.4606 46.536 68.0873 46.6107 68.6153 46.76C69.1433 46.904 69.5779 47.1147 69.9193 47.392C70.2659 47.6693 70.5219 48.0053 70.6873 48.4C70.8526 48.7893 70.9353 49.2267 70.9353 49.712C70.9353 50.1173 70.8713 50.496 70.7433 50.848C70.6153 51.2 70.4286 51.5173 70.1833 51.8C69.9433 52.0773 69.6473 52.3147 69.2953 52.512C68.9486 52.7093 68.5539 52.8587 68.1113 52.96C68.3086 53.072 68.4793 53.2347 68.6233 53.448L71.9673 58ZM75.0785 58H73.5265V46.536H75.0785V58ZM89.9389 46.536V58H88.5789V49.576C88.5789 49.464 88.5815 49.344 88.5869 49.216C88.5975 49.088 88.6082 48.9573 88.6189 48.824L84.6829 55.992C84.5602 56.232 84.3735 56.352 84.1229 56.352H83.8989C83.6482 56.352 83.4615 56.232 83.3389 55.992L79.3229 48.792C79.3549 49.0747 79.3709 49.336 79.3709 49.576V58H78.0109V46.536H79.1549C79.2935 46.536 79.4002 46.5493 79.4749 46.576C79.5495 46.6027 79.6215 46.6773 79.6909 46.8L83.6509 53.856C83.7149 53.984 83.7762 54.1173 83.8349 54.256C83.8989 54.3947 83.9575 54.536 84.0109 54.68C84.0642 54.536 84.1202 54.3947 84.1789 54.256C84.2375 54.112 84.3015 53.976 84.3709 53.848L88.2589 46.8C88.3229 46.6773 88.3922 46.6027 88.4669 46.576C88.5469 46.5493 88.6562 46.536 88.7949 46.536H89.9389ZM94.4223 58H92.8703V46.536H94.4223V58ZM100.531 52.088C100.979 52.088 101.373 52.0347 101.715 51.928C102.061 51.816 102.349 51.6613 102.579 51.464C102.813 51.2613 102.989 51.0213 103.107 50.744C103.224 50.4667 103.283 50.16 103.283 49.824C103.283 49.1413 103.059 48.6267 102.611 48.28C102.163 47.9333 101.491 47.76 100.595 47.76H98.8986V52.088H100.531ZM105.827 58H104.451C104.168 58 103.96 57.8907 103.827 57.672L100.851 53.576C100.76 53.448 100.661 53.3573 100.555 53.304C100.453 53.2453 100.293 53.216 100.075 53.216H98.8986V58H97.3546V46.536H100.595C101.32 46.536 101.947 46.6107 102.475 46.76C103.003 46.904 103.437 47.1147 103.779 47.392C104.125 47.6693 104.381 48.0053 104.547 48.4C104.712 48.7893 104.795 49.2267 104.795 49.712C104.795 50.1173 104.731 50.496 104.603 50.848C104.475 51.2 104.288 51.5173 104.043 51.8C103.803 52.0773 103.507 52.3147 103.155 52.512C102.808 52.7093 102.413 52.8587 101.971 52.96C102.168 53.072 102.339 53.2347 102.483 53.448L105.827 58Z"
        fill={secondaryColor}
      />
    </svg>
  );
};

export default React.memo(BoxLabelPrintingIcon);
